//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * The method is used to transfer certain users from the abas by logins (ex 18813.07)
 * @param passwordToSet (optional) The password that will be set for all transferred users. If not specified, the generated password is used
 * @param sendEmail (optional) 
 */
export function transferUsersFromAbasByLogin(logins: string[], passwordToSet?: string | null | undefined, sendEmail?: boolean | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/web-users/transfer?";
    if (passwordToSet !== undefined && passwordToSet !== null)
        url_ += "passwordToSet=" + encodeURIComponent("" + passwordToSet) + "&";
    if (sendEmail === null)
        throw new Error("The parameter 'sendEmail' cannot be null.");
    else if (sendEmail !== undefined)
        url_ += "sendEmail=" + encodeURIComponent("" + sendEmail) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(logins);

    let options_: AxiosRequestConfig = {
        ..._requestConfigTransferUsersFromAbasByLogin,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigTransferUsersFromAbasByLogin?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processTransferUsersFromAbasByLogin(_response);
    });
}

function processTransferUsersFromAbasByLogin(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Syncs users with the ABAS. Uses the same logic as abasUpdaterJob
 * @param executeFrom (optional) Users who created in Abas starting from this date will be updated or created in the app
 * @param sendEmail (optional) Is it necessary to send a welcome letter
 * @param importUsersCreatedInAbasAfter (optional) Optional filter: if set, only import users whose Abas CreatedAt is strictly greater than this timestamp.By default it equals DateTime.MaxValue
 * @param dryRun (optional) If true, run a non-destructive simulation: actions are logged but no changes are persisted and no emails are sent.
 */
export function syncAbasWebUsers(executeFrom?: Date | undefined, sendEmail?: boolean | undefined, importUsersCreatedInAbasAfter?: Date | null | undefined, dryRun?: boolean | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/web-users/sync-users?";
    if (executeFrom === null)
        throw new Error("The parameter 'executeFrom' cannot be null.");
    else if (executeFrom !== undefined)
        url_ += "executeFrom=" + encodeURIComponent(executeFrom ? "" + executeFrom.toISOString() : "") + "&";
    if (sendEmail === null)
        throw new Error("The parameter 'sendEmail' cannot be null.");
    else if (sendEmail !== undefined)
        url_ += "sendEmail=" + encodeURIComponent("" + sendEmail) + "&";
    if (importUsersCreatedInAbasAfter !== undefined && importUsersCreatedInAbasAfter !== null)
        url_ += "importUsersCreatedInAbasAfter=" + encodeURIComponent(importUsersCreatedInAbasAfter ? "" + importUsersCreatedInAbasAfter.toISOString() : "") + "&";
    if (dryRun === null)
        throw new Error("The parameter 'dryRun' cannot be null.");
    else if (dryRun !== undefined)
        url_ += "dryRun=" + encodeURIComponent("" + dryRun) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSyncAbasWebUsers,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSyncAbasWebUsers?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSyncAbasWebUsers(_response);
    });
}

function processSyncAbasWebUsers(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Check Deleted Users.
 */
export function checkDeletedUsers(config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/web-users/check-deleted-users";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigCheckDeletedUsers,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCheckDeletedUsers?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCheckDeletedUsers(_response);
    });
}

function processCheckDeletedUsers(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigTransferUsersFromAbasByLogin: Partial<AxiosRequestConfig> | null;
export function getTransferUsersFromAbasByLoginRequestConfig() {
  return _requestConfigTransferUsersFromAbasByLogin;
}
export function setTransferUsersFromAbasByLoginRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigTransferUsersFromAbasByLogin = value;
}
export function patchTransferUsersFromAbasByLoginRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigTransferUsersFromAbasByLogin = patch(_requestConfigTransferUsersFromAbasByLogin ?? {});
}

let _requestConfigSyncAbasWebUsers: Partial<AxiosRequestConfig> | null;
export function getSyncAbasWebUsersRequestConfig() {
  return _requestConfigSyncAbasWebUsers;
}
export function setSyncAbasWebUsersRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSyncAbasWebUsers = value;
}
export function patchSyncAbasWebUsersRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSyncAbasWebUsers = patch(_requestConfigSyncAbasWebUsers ?? {});
}

let _requestConfigCheckDeletedUsers: Partial<AxiosRequestConfig> | null;
export function getCheckDeletedUsersRequestConfig() {
  return _requestConfigCheckDeletedUsers;
}
export function setCheckDeletedUsersRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCheckDeletedUsers = value;
}
export function patchCheckDeletedUsersRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCheckDeletedUsers = patch(_requestConfigCheckDeletedUsers ?? {});
}